<div class="background">
  <img class="img" [ngSrc]="feedImage" alt="" fill />
</div>
